import * as React from "react";
import {
  DataGrid,
  GridFooterContainer,
  useGridApiContext,
  useGridSelector,
  gridRowCountSelector,
  gridPageSelector,
  gridPageCountSelector,
} from "@mui/x-data-grid";
import { Pagination } from "@mui/material";
import PropTypes from "prop-types";

const PAGE_SIZE = 20;

function CustomFooter() {
  const apiRef = useGridApiContext();
  const page = useGridSelector(apiRef, gridPageSelector);
  const pageCount = useGridSelector(apiRef, gridPageCountSelector);
  const rowCount = useGridSelector(apiRef, gridRowCountSelector);

  const from = rowCount === 0 ? 0 : page * PAGE_SIZE + 1;
  const to = Math.min((page + 1) * PAGE_SIZE, rowCount);
  const totalPages = Math.max(pageCount, 1);

  return (
    <GridFooterContainer>
      <div style={{ padding: "0 16px", fontSize: "13px" }}>
        {`${from}-${to} / ${rowCount}件`}
      </div>
      <Pagination
        count={totalPages}
        page={page + 1}
        onChange={(_, value) => apiRef.current.setPage(value - 1)}
        size="small"
      />
    </GridFooterContainer>
  );
}

const columns = [
  {
    field: "NickName",
    headerName: "表示名",
    width: 150,
  },
  {
    field: "Created",
    headerName: "測定日時",
    width: 180,
  },
  {
    field: "Name",
    headerName: "計測種目",
    width: 180,
  },
  {
    field: "ResultValues",
    headerName: "測定結果",
    width: 180,
  },
  { field: "id", headerName: "システムID", sortable: false, width: 320 },
];

export default function MeasurementDataTable({
  measurements,
  setTargetMeasurements,
  loading,
}) {
  const clicked2 = (ids) => {
    const selectedIDs = new Set(ids);
    const selectedRowData = (measurements ?? []).filter((row) =>
      selectedIDs.has(row.id.toString())
    );

    setTargetMeasurements(selectedRowData);
  };

  return (
    <div style={{ width: "100%" }}>
      <DataGrid
        rows={measurements ?? []}
        loading={loading ?? false}
        columns={columns}
        pageSize={PAGE_SIZE}
        rowsPerPageOptions={[PAGE_SIZE]}
        checkboxSelection={true}
        density="compact"
        autoHeight
        onSelectionModelChange={(ids) => clicked2(ids)}
        components={{ Footer: CustomFooter }}
        initialState={{ sorting: { sortModel: [{ field: "Created", sort: "desc" }] } }}
      />
    </div>
  );
}

MeasurementDataTable.propTypes = {
  measurements: PropTypes.object,
  setTargetMeasurements: PropTypes.any,
  loading: PropTypes.bool,
};
